import axios from "axios";
import { apiBase } from "@/constants";

export default {
  state: {
    registrationName: '',
    registrationLogin: '',
    registrationEmail: '',
    registrationPassword: '',
    registrationRepeatPassword: '',
    isRegistrationNameValid: false,
    isRegistrationLoginValid: false,
    isRegistrationEmailValid: false,
    isRegistrationPasswordValid: false,
    isRegistrationPasswordMatch: true,
    registrationLicenseAgreed: false,
    usernameIsAlreadyTaken: false,
    emailIsAlreadyTaken: false
  },
  getters: {
    registrationName: state => state.registrationName,
    registrationLogin: state => state.registrationLogin,
    registrationEmail: state => state.registrationEmail,
    registrationPassword: state => state.registrationPassword,
    registrationRepeatPassword: state => state.registrationRepeatPassword,
    isRegistrationPasswordMatch: state => state.isRegistrationPasswordMatch,
    registrationLicenseAgreed: state => !!state.registrationLicenseAgreed,
    allRegistrationFieldsValid: state => state.isRegistrationNameValid
          && state.isRegistrationLoginValid
          && state.isRegistrationEmailValid
          && state.isRegistrationPasswordValid
          && state.isRegistrationPasswordMatch
          && state.registrationLicenseAgreed
          && !state.emailIsAlreadyTaken
          && !state.usernameIsAlreadyTaken,
    usernameIsAlreadyTaken: state => state.usernameIsAlreadyTaken,
    emailIsAlreadyTaken: state => state.emailIsAlreadyTaken
  },
  mutations: {
    updateRegistrationName(state, value) {
      state.registrationName = value;
    },
    updateRegistrationLogin(state, value) {
      state.registrationLogin = value;
    },
    updateRegistrationEmail(state, value) {
      state.registrationEmail = value;
    },
    updateRegistrationPassword(state, value) {
      state.registrationPassword = value;
    },
    updateRegistrationRepeatPassword(state, value) {
      state.registrationRepeatPassword = value;
    },
    updateIsRegistrationNameValid(state, value) {
      state.isRegistrationNameValid = value;
    },
    updateIsRegistrationLoginValid(state, value) {
      state.isRegistrationLoginValid = value;
    },
    updateIsRegistrationEmailValid(state, value) {
      state.isRegistrationEmailValid = value;
    },
    updateIsRegistrationPasswordValid(state, value) {
      state.isRegistrationPasswordValid = value;
    },
    updateIsRegistrationPasswordMatch(state, value) {
      if (state.isRegistrationPasswordValid) state.isRegistrationPasswordMatch = value;
    },
    updateRegistrationLicenseAgreed(state, value) {
      state.registrationLicenseAgreed = value;
    },
    setUsernameIsAlreadyTaken(state) {
      state.usernameIsAlreadyTaken = true;
    },
    setEmailIsAlreadyTaken(state) {
      state.emailIsAlreadyTaken = true;
    },
    clearRegistrationErrors(state) {
      state.usernameIsAlreadyTaken = false;
      state.emailIsAlreadyTaken = false;
    }
  },
  actions: {
    fillLoginWithRegistrationDetails: ({ state, commit }) => {
      const payload = {
        registrationEmail: state.registrationEmail,
        registrationPassword: state.registrationPassword
      };

      commit('fillLoginWithRegistrationDetails', payload);
    },
    register: ({ state, getters, commit }, payload) => new Promise((resolve, reject) => {
      if (!getters.allRegistrationFieldsValid) return;

      axios.post(`${apiBase}/register`,
        {
          username: state.registrationLogin,
          email: state.registrationEmail,
          password: state.registrationPassword,
          fullname: state.registrationName
        })
        .then((response) => {
          if (response.status === 201) {
            resolve(payload);
          } else {
            reject(response);
          }
        })
        .catch((err) => {
          commit('setLoading', false);
          commit('setLoadingMessage', '');
          const { response } = err;
          if (err.response === undefined && err.status !== 201) {
            commit('setConnectionAuthError');
          } else if (response.status === 400) {
            if (response.data.code === "email_in_use") {
              commit('setEmailIsAlreadyTaken');
            } else if (response.data.code === "username_in_use") {
              commit('setUsernameIsAlreadyTaken');
            }
          } else commit('setUnknownAuthError');
        });
    })
  }
};
